export default ({ get, checkStatus, toJSON }) => ({
  getLayout: () =>
    get(`universe/v2/home_page_blue_prints`).then(checkStatus).then(toJSON),
});
